import { RefObject, useEffect, useState } from 'react';

export function useHeaderMobilePositionControl({
  enabled,
  headerRef,
}: {
  enabled: boolean;
  headerRef: RefObject<HTMLElement | null>;
}) {
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const isMobile = window.innerWidth <= 640;

    if (!enabled || !headerRef.current || !isMobile) {
      if (headerRef.current) {
        headerRef.current.style.position = ''; // delete style inline
      }

      return;
    }

    const element = headerRef.current;

    const handleScroll = () => {
      const offset = parseFloat(
        getComputedStyle(document.documentElement)
          .getPropertyValue('--header-offset')
          .trim(),
      );

      const currentScroll = window.scrollY;

      const isScrollingDown = currentScroll > lastScrollY;

      if (offset === 0 && isScrollingDown) {
        element.style.position = 'fixed';
      } else {
        element.style.position = 'absolute';
      }

      setLastScrollY(currentScroll);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [enabled, headerRef]);
}
